import { api } from "../../apiProvider";
import { WfsServiceService } from "./wfsService.service";
import { Projection } from "../../../common/types";

export const defaultParams = {
    service: "wfs",
    version: "2.0.0",
    request: "GetFeature",
    outputFormat: "application/json",
    srsName: Projection.EPSG_4326,
};

export const wfsServiceAdapter: WfsServiceService = async (params) => {
    const merged = { ...defaultParams, ...params };

    const requestParams = Object.keys(merged)
        .map((key) => {
            return key + "=" + (merged as any)[key];
        })
        .join("&");
    const resp = await api.wfsService(requestParams);

    return {
        ...resp.data,
        features: resp.data.features.map((apiFeature) => ({
            ...apiFeature,
            properties: {
                parentId: apiFeature.properties.PARENT_ID,
                parentLayerName: apiFeature.properties.PARENT_LAYER_NAME,
                id: `${apiFeature.properties.FEATURE_ID}`,
                featureType: apiFeature.properties.FEATURE_FORM,
                featureId: apiFeature.properties.FEATURE_ID,
                featureForm: apiFeature.properties.FEATURE_FORM,
                featureShortName: apiFeature.properties.FEATURE_SHORT_NAME,
                slotId: apiFeature.properties.SLOT_ID,
                naturalKey: apiFeature.properties.NATURAL_KEY,
                layer: apiFeature.properties.LAYER_NAME,
                name: apiFeature.properties.ENTITY_NAME,
                upperLimit: apiFeature.properties.UPPER_LIMIT,
                lowerLimit: apiFeature.properties.LOWER_LIMIT,
                rightWidth: apiFeature.properties.RIGHT_WIDTH,
                leftWidth: apiFeature.properties.LEFT_WIDTH,
            },
        })),
    };
};
